import { City } from "@prisma/client"
import type { Facet } from "data/facets"
import { useTranslation } from "react-i18next"

export const FacetName = ({
  facetKey,
  isFilter,
  city,
}: {
  facetKey: Facet["field"]["field"] | Facet["title"]
  isFilter?: boolean
  city?: City
}) => {
  const { t } = useTranslation(["facets"])
  const textSizeCx = isFilter ? "text-[11px] leading-tight" : "text-sm"
  const translationKey = `facets:${facetKey}`
  const facetName = t([
    `${translationKey}.name.${city}`,
    `${translationKey}.name`, // If there's no city specific use the default
  ])
  return <span className={`${textSizeCx} mr-1 text-left align-middle`}>{facetName}</span>
}
